import { render, staticRenderFns } from "./ThgPrivacy.vue?vue&type=template&id=42f9cc14&scoped=true"
import script from "./ThgPrivacy.vue?vue&type=script&lang=ts"
export * from "./ThgPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./ThgPrivacy.vue?vue&type=style&index=0&id=42f9cc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f9cc14",
  null
  
)

export default component.exports